module.exports = __webpack_public_path__ + "img/02.e92597a9.jpg";